
// SVG Icon: compass-outer-enlarged
export default { id: "terriajs-compass-outer-enlarged" };
export const id = "terriajs-compass-outer-enlarged";
export const name = "compass-outer-enlarged";
